"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Permissions;
(function (Permissions) {
    Permissions["AdministrationView"] = "Frends.Administration.View";
    Permissions["ApiKeyManagementAdmin"] = "Frends.ApiKeyManagement.Admin";
    Permissions["ApiManagementView"] = "Frends.ApiManagement.View";
    Permissions["ApiManagementEdit"] = "Frends.ApiManagement.Edit";
    Permissions["ApiManagementDeploy"] = "Frends.ApiManagement.Deploy";
    Permissions["EnvironmentEdit"] = "Frends.Environment.Edit";
    Permissions["EnvironmentVariablesEdit"] = "Frends.EnvironmentVariables.Edit";
    Permissions["MonitoringRulesView"] = "Frends.MonitoringRules.View";
    Permissions["ProcessEdit"] = "Frends.Process.Edit";
    Permissions["ProcessStart"] = "Frends.Process.Start";
    Permissions["ProcessDeploy"] = "Frends.Process.Deploy";
    Permissions["ProcessView"] = "Frends.Process.View";
    Permissions["ProcessInstanceEdit"] = "Frends.ProcessInstance.Edit";
    Permissions["SubProcessEdit"] = "Frends.Process.Edit";
    Permissions["TaskView"] = "Frends.Task.View";
    Permissions["UserManagementAdmin"] = "Frends.UserManagement.Admin";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
exports.AllPermissionsTrue = (_a = {},
    _a[Permissions.ApiManagementView] = true,
    _a[Permissions.ApiManagementEdit] = true,
    _a[Permissions.ApiManagementDeploy] = true,
    _a[Permissions.ProcessView] = true,
    _a[Permissions.ProcessEdit] = true,
    _a[Permissions.ProcessStart] = true,
    _a[Permissions.ProcessDeploy] = true,
    _a[Permissions.EnvironmentVariablesEdit] = true,
    _a[Permissions.AdministrationView] = true,
    _a[Permissions.EnvironmentEdit] = true,
    _a[Permissions.TaskView] = true,
    _a[Permissions.MonitoringRulesView] = true,
    _a[Permissions.UserManagementAdmin] = true,
    _a[Permissions.ApiKeyManagementAdmin] = true,
    _a[Permissions.ProcessInstanceEdit] = true,
    _a);
var _a;



//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/model/AllPermissions.ts
// module id = 73
// module chunks = 1 2 3 6